import React from 'react';
import Home from '@component/gridgio/lab/home';
import PageTemplate from '@page/gridgio/page-template';
import Scroll from '@component/common/scroll';
import * as color from '@constant/color';

const LabHomePage: React.FC = () => (
  <PageTemplate customHeader='none' title='실험실' mode='page' backgroundColor={color.GRAY_BACKGROUND_COLOR}>
    <Scroll direction='y' height='100%'>
      <Home />
    </Scroll>
  </PageTemplate>
);

export default LabHomePage;
